import { render } from "./KioskWrapper.vue?vue&type=template&id=54d6ad7a&scoped=true&ts=true"
import script from "./KioskWrapper.vue?vue&type=script&lang=ts"
export * from "./KioskWrapper.vue?vue&type=script&lang=ts"

import "./KioskWrapper.vue?vue&type=style&index=0&id=54d6ad7a&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d6ad7a"]])

export default __exports__